import {useEffect} from 'react';
import {dispatcher} from '@netx/core-next/instance/dispatcher';

/**
 * Use Netx Backbone `dispatcher`
 * @param event `dispatcher` event
 * @param cb `dispatcher` callback
 * @param once listen once
 * @example
 * useDispatcher('some:event', (data) => {...});
 */
export const useDispatcher = (
	event: string,
	cb: (...args: any) => void,
	once?: boolean,
) => {
	useEffect(() => {
		once ? dispatcher.once(event, cb) : dispatcher.on(event, cb);
		return () => {
			dispatcher.off(event, cb);
		};
	}, [cb, event, once]);
};

export default useDispatcher;
